import { Controller } from 'lib_ts/enums/routing/controllers';
import { TailscaleRoutes } from 'lib_ts/enums/routing/routes/tailscale';
import { IServerResponse } from 'lib_ts/interfaces/common/i-server-response';
import { BaseRESTService } from 'services/_base-rest.service';

export class TailscaleService extends BaseRESTService {
  private static instance: TailscaleService;
  static getInstance(): TailscaleService {
    if (!TailscaleService.instance) {
      TailscaleService.instance = new TailscaleService();
    }

    return TailscaleService.instance;
  }

  private constructor() {
    super({
      controller: Controller.Tailscale,
    });
  }

  async createAuthKey(machineID: string): Promise<boolean> {
    return await this.get({
      uri: `${TailscaleRoutes.CreateAuthKey}/${machineID}`,
    })
      .then((result: IServerResponse) => result.data)
      .catch((reason) => {
        console.error(reason);
        return false;
      });
  }
}
